import { produce } from "immer";
import * as Actions from "pages/Quarantine/store/quarantinesActions";

import deepmerge from "deepmerge";
import combineMerge from "config/combineMerge";

const initialState = { byId: {}, allIds: [], hasMore: true };
const quarantinesReducer = produce((draft, action) => {
  switch (action.type) {
    case Actions.FETCH_QUARANTINES_SUCCESS: {
      const payload = action.payload;
      const quarantines = payload.quarantines;
      const quarantineIds = payload.quarantines.map(
        quarantine => quarantine.message_id
      );

      const byId = quarantines.reduce((obj, quarantine) => {
        obj[quarantine.message_id] = quarantine;
        return obj;
      }, {});

      draft.byId = deepmerge(draft.byId, byId, {
        arrayMerge: combineMerge
      });
      draft.allIds = quarantineIds;
      draft.hasMore = quarantineIds.length >= (payload.perPage || 20);

      break;
    }

    case Actions.FETCH_QUARANTINES_APPEND_SUCCESS: {
      const payload = action.payload;
      const quarantines = payload.quarantines;
      const quarantineIds = quarantines.map(
        quarantine => quarantine.message_id
      );

      const byId = quarantines.reduce((obj, quarantine) => {
        obj[quarantine.message_id] = quarantine;
        return obj;
      }, {});

      draft.byId = deepmerge(draft.byId, byId, {
        arrayMerge: combineMerge
      });
      const newIds = quarantineIds.filter(id => !draft.allIds.includes(id));
      draft.allIds = [...draft.allIds, ...newIds];
      draft.hasMore = quarantineIds.length >= (payload.perPage || 20);

      break;
    }

    case Actions.DELETE_ITEMS: {
      const { data } = action.payload;
      data.map(item => {
        if (item in draft.byId) {
          draft.byId[item].deleted = true;
        }

        return true;
      });
      break;
    }

    default:
      return draft;
  }
}, initialState);

export default quarantinesReducer;
